import React from 'react';
import CrdManage from '@/components/CrdManage';
import {CrdManageType} from '@/dicts/crd';

export default function CrdView() {
    return (
        <>
            <CrdManage type={CrdManageType.VIEW} />
        </>
    );
}
